import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private searchTermSource = new BehaviorSubject<string>('');  // Store search term
  currentSearchTerm$ = this.searchTermSource.asObservable();   // Observable to subscribe

  constructor() {}

  updateSearchTerm(term: string): void {
    this.searchTermSource.next(term);  // Update search term
  }
}